module.exports = __webpack_public_path__ + "img/MOBILE.c1eb0f75.svg";